<template>
  <div>
    <b-row v-if="!readOnly">
      <b-col class="visualizar">
        <b-button variant="link" class="link"
          ><Visualizar /> Visualizar</b-button
        >
      </b-col>
    </b-row>
    <b-row v-if="!readOnly">
      <b-col>
        <Modal
          :title="title"
          :text="paragraph"
          :uno="textOne"
          :dos="textTwo"
          :tres="textTrhee"
          :cuatro="textFour"
          :cinco="textFive"
          :seis="textSix"
        />
      </b-col>
      <b-col class="btn-direction-flex">
        <b-button
          pill
          variant="primary"
          class="btn-one"
          @click="guardarBorrador"
          v-if="userPermissions"
          >Guardar como borrador</b-button
        >
        <b-button
          pill
          variant="primary"
          class="btn-two"
          @click="guardarFinalizado"
          v-if="userPermission"
          >Guardar y finalizar</b-button
        >
      </b-col>
    </b-row>
    <div>
      <b-row>
        <b-col class="title"> <h2 style="font-weight: bold;">Leyes</h2> </b-col>
      </b-row>

      <b-row v-if="userPermissions" class="Checkbox-form">
        <b-form-checkbox
          style="display:flex;   justify-content: flex-end; "
          v-model="checkeds"
          name="check-button"
          switch
        >
          <span class="span" v-if="checkeds"> No Aplica</span>
          <span class="span" v-else>No Aplica</span>
        </b-form-checkbox>
      </b-row>

      <b-row v-if="checkeds">
        <AlertError />
      </b-row>

      <b-row v-else>
        <b-row>
          <h3 class="title-leyes">{{ titleRows2 }}</h3>
        </b-row>
        <LeyesPromulgadasList
          :listaLeyesPromulgadas="listaLeyesPromulgadas"
          :addItemList="addItemList"
          :removeItem="removeItem"
          :readOnly="readOnly"
        />
      </b-row>
    </div>
  </div>
</template>

<script>
import Visualizar from "../../../../../components/image/icon/Visualizar.vue";
import LeyesPromulgadasList from "./LeyesPromulgadasList.vue";
import Modal from "../../../../../components/tools/Modal.vue";
import { showAlert } from "../../../../../components/tools/utils";
import Swal from "sweetalert2";
import { mapState } from "vuex";
import axios from "axios";
import AlertError from "../../../../../components/error/AlertError.vue";
export default {
  components: {
    Visualizar,
    Modal,
    LeyesPromulgadasList,
    AlertError,
  },
  data() {
    return {
      nombre: "leyes",
      listaLeyesPromulgadas: [],
      existingData: null,
      titleRows2: `Anexo 10b: Leyes Promulgadas durante ${process.env.VUE_APP_ANIO}`,
      title: `Leyes Promulgadas durante ${process.env.VUE_APP_ANIO} `,
      paragraph: "Para cada Ley promulgada señalar:",
      textOne: "N° Ley:",
      textTwo: "Fecha de promulgación:",
      textTrhee: "Fecha de entrada en Vigencia::",
      textFive: "Materia:",
      userPermission: true,
      userPermissions: true,
      datosUser: null,
      checkeds: false,
    };
  },
  props: ["readOnly"],
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    guardarBorrador: async function() {
      try {
        const toSend = this.buildData("borrador");

        const objSend = {
          ...toSend,
          data: {
            ...this.existingData,
            leyesPromulgadas: this.listaLeyesPromulgadas,
            aplico: this.checkeds,
          },
        };

        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
          objSend,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Guardado como Borrador Exitoso",
          timerProgressBar: true,
          timer: 3000,
        });
      } catch (error) {
        if (error.response.status === 422) {
          const toSend = {
            nombre: this.nombre,
            elaboracion: "borrador",
            data: {
              ...this.existingData,
              leyesPromulgadas: this.listaLeyesPromulgadas,
              aplico: this.checkeds,
            },
            anio: process.env.VUE_APP_ANIO,
          };

          await axios.put(
            `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
            toSend,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          );
          showAlert({
            icon: "success",
            text: "Guardado como Borrador Exitoso",
            timerProgressBar: true,
            timer: 3000,
          });
        } else {
          console.log(error);
          showAlert({
            icon: "error",
            text: error.response.data[Object.keys(error.response.data)[0]],
            timerProgressBar: true,
            timer: 3000,
          });
        }
      }
    },
    guardarFinalizado: async function() {
      Swal.fire({
        title: "Guardar y Finalizar",
        text: "¿Desea guardar el documento?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Confirmar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const toSend = this.buildData("borrador");

            const objSend = {
              ...toSend,
              data: {
                ...this.existingData,
                leyesPromulgadas: this.listaLeyesPromulgadas,
                aplico: this.checkeds,
              },
            };

            await axios.post(
              `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/`,
              objSend,
              {
                headers: {
                  Authorization: `JWT ${localStorage.getItem("userToken")}`,
                },
              }
            );

            showAlert({
              icon: "success",
              text: "Guardando Datos",
              timerProgressBar: true,
              timer: 3000,
            });
          } catch (error) {
            if (error.response.status === 422) {
              const toSend = {
                nombre: this.nombre,
                elaboracion: "finalizado",
                data: {
                  ...this.existingData,
                  leyesPromulgadas: this.listaLeyesPromulgadas,
                  aplico: this.checkeds,
                },
                anio: process.env.VUE_APP_ANIO,
              };

              await axios.put(
                `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/`,
                toSend,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              );
              showAlert({
                icon: "success",
                text: "Guardado y finalizado exitosamente.",
                timerProgressBar: true,
                timer: 3000,
              });
            } else {
              console.log(error);
              showAlert({
                icon: "error",
                text: error.response.data[Object.keys(error.response.data)[0]],
                timerProgressBar: true,
                timer: 3000,
              });
            }
          }
          this.$router.push({
            name: "buttons",
            params: { idUsuario: this.usuario.id },
          });
        }
      });
    },
    buildData: function(type) {
      return {
        nombre: this.nombre,
        elaboracion: type,
        anio: process.env.VUE_APP_ANIO,
        idServicio: this.$route.params.idServicio,
      };
    },
    addItemList: function() {
      const toAddObj = {
        nLey: "",
        fechaPromulgacion: "",
        fechaIngresoVigencia: "",
        materia: "",
      };
      this.listaLeyesPromulgadas.push(toAddObj);
    },
    removeItem: function(index) {
      if (this.readOnly) return;
      const pos = this.listaLeyesPromulgadas.indexOf(index);

      this.listaLeyesPromulgadas.splice(pos, 1);
    },
    obtenerBorrador: async function() {
      try {
        const obj = {
          anio: process.env.VUE_APP_ANIO,
          nombre: "leyes",
        };
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/secciones/${this.$route.params.idServicio}/?anio=${obj.anio}&nombre=${obj.nombre}`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.existingData = res.data.info;
        this.checkeds = res.data.info.aplico;
        if (res.data.info.leyesPromulgadas) {
          this.listaLeyesPromulgadas = res.data.info.leyesPromulgadas;
        }
      } catch (error) {
        console.log(error);
      }
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;

        console.log("Hola mundo", this.datosUser);

        const data = JSON.parse(localStorage.getItem("user"));
        const relacionUs = data.servicios.find(
          (s) => s.id === parseInt(this.$route.params.idServicio)
        );
        if (!relacionUs) return;
        console.log("revisando user", relacionUs);

        //funcionario Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 5)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI Borrador
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermissions = false;
        }

        //Encargado BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "jefe_servicio" ||
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 4)
        ) {
          this.userPermission = false;
        }

        //Jefe de Servicio BGI Borrador
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermissions = false;
        }

        //Jefe de Servicio BGI fibalizado
        if (
          this.datosUser.siguienteAccion === "representante_ministerial" ||
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 3)
        ) {
          this.userPermission = false;
        }

        //Funcionario
        if (relacionUs.rolId === 5) {
          this.userPermission = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },
  },
  mounted() {
    this.obtenerBorrador();
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
  },
};
</script>

<style scoped>
.row {
  margin: 0;
}

.span {
  font-size: 18px;
  color: #052333;
  font-weight: 600;
  display: grid;
  top: -10px;
}

.visualizar {
  text-align: end;
}

.link {
  color: #052333;
  display: inline-flex;
  margin-bottom: 10px;
}

.link-two {
  display: flex;
  color: #052333;
}

.link-two:hover {
  color: #052333;
}

.link:hover {
  color: #052333;
}

.btn-direction-flex {
  text-align: end;
}

.btn-one {
  margin-right: 20px;
}

.title-leyes {
  font-size: 20px;
}

.title {
  margin-top: 20px;
  text-align: center;
  color: #052333;
}

@media screen and (max-width: 784px) {
  .link-two {
    font-size: 10px;
  }
  .btn-one {
    font-size: 11px;
    margin-right: 5px;
  }
  .btn-two {
    font-size: 11px;
  }
}

@media screen and (max-width: 569px) {
  .link-two {
    font-size: 10px;
  }
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}

@media screen and (max-width: 417px) {
  .btn-one {
    font-size: 10px;
    margin-right: 5px;
    width: 90px;
    margin-bottom: 15px;
  }
  .btn-two {
    font-size: 10px;
    width: 90px;
  }
}
</style>
